import type { ReactElement } from 'react'

import { useAuthState } from '@percent/admin-dashboard/common/hooks'
import { usePermissions } from '@percent/admin-dashboard/common/hooks/usePermissions'
import { POSTHOG_FEATURE_FLAGS } from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { AccessRoute } from './AccessRoute'
import { FeatureRoute } from './FeatureRoute'

/**
 * The accounts pages. An admin who can list accounts gets in as before; any other only while the services
 * flag is on, as the Services tab is open to every internal admin and the API decides what each sees there.
 */
export function AccountsRoute({ children }: Readonly<{ children: ReactElement }>) {
  const { permissionsSet } = useAuthState()
  const { userHasPermissions } = usePermissions()

  if (permissionsSet && !userHasPermissions('accounts:can_list')) {
    return <FeatureRoute flag={POSTHOG_FEATURE_FLAGS.AD_SERVICES}>{children}</FeatureRoute>
  }

  return <AccessRoute permissions="accounts:can_list">{children}</AccessRoute>
}
